import {
  DIM2CLASS
} from '../core/icon-class';

class FilterSearchController {
  constructor(
    $scope,
    $http,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    RouterService,
    FilterResource,
  ) {
    this.$scope = $scope;
    this.$http = $http;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.value = '';
    this.previousValue = this.value;
    // this.title = gettext('Поиск - Ключевые слова');
    // this.titleCatalog = gettext('Поиск - Имя фильтра');
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  searchKeyup(event) {
    if (event.keyCode !== 13) {
      return;
    }
    return this.search();
  }

  searchClean() {
    this.value = '';
    this.search();
  }

  getKeywordsArr(str) {
    let wBegin = 0;
    let isQuoted = false;
    const arr = [];
    let i = 0;
    for (i; i < str.length; i++) {
      if (!isQuoted && str[i] == ' ') {
        if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
        wBegin = i + 1;
      } else if (!isQuoted && str[i] == '"') {
        if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
        wBegin = i + 1;
        isQuoted = true;
      } else if (isQuoted && str[i] == '"') {
        isQuoted = false;
        if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
        wBegin = i + 1;
      }
    }
    if (i - wBegin) arr.push(str.substr(wBegin, i - wBegin).trim());
    return arr;
  }


  search() {
    if (this.router.isFilterEditModal) {
      this.$scope.runClick({
        keyWord: this.value
      });
      // this.$scope.runClick(this.value);
    } else {
      const keywords = this.value;
      if (!keywords.trim()) {
        return;
      }

      // const keywordsArrOld = keywords.split(' ')
      //   .map(keyword => {
      //     const re = keyword.match(/["'](.*)["']/);
      //     return re && re[1] || keyword;
      //   });

      const keywordsArr = this.getKeywordsArr(keywords);

      // Promise.all(keywordsArr.map(keyword => this.FilterResource.checkRegExp(keyword)))
      this.FilterResource.checkRegExps(keywordsArr)
        .then(err => {
          if (err) {
            this.error = err;
            if (!this.$scope.$root.$$phase) this.$scope.$root.$apply();
            return null;
          }
          keywordsArr.map(keyword => {
            this.router.addKeyword(keyword);
          });
          this.value = '';
          if (!this.$scope.$root.$$phase) this.$scope.$root.$apply();
        });
    }
  }
}

export function FilterSearchComponent() {
  return {
    restrict: 'E',
    template: require('./filter-search.component.html'),
    // scope: true,
    scope: {
      runClick: '&'
    },
    controller: FilterSearchController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/filter-search.component.js